import React from "react";
import { useParams, Navigate } from "react-router-dom";

import KioskoPage from "../../components/kiosko/kiosko.page";
import { useKioskoBySlug } from "../../services/microservice/agents/sponsors/use-sponsors";

const KioskoSlugPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const { data: config, isLoading, isError } = useKioskoBySlug(slug);

  if (isLoading) {
    return (
      <div className="fixed inset-0 z-[9999] flex h-screen w-full items-center justify-center bg-white">
        <div className="flex flex-col items-center space-y-4">
          <div className="h-20 w-20 animate-spin rounded-full border-8 border-textSecundary border-t-background" />
          <p className="text-gray-500 text-lg">Cargando...</p>
        </div>
      </div>
    );
  }

  if (isError || !config) {
    return <Navigate to="/not-found" replace />;
  }

  return <KioskoPage config={config} />;
};

export default KioskoSlugPage;
